import { apiSlice } from "../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getRecent: builder.query({
            query: () => ({
                url: "/users/getRecents",
                method: "GET",
            }),

        }),
    }),
});

export const { useGetRecentQuery } = sqlApiSlice; 
